export const getClipboardWriteErrorMessage = () => {
    if (typeof window !== 'undefined' && !window.isSecureContext) {
        return 'Системное копирование недоступно в текущем окружении. Откройте приложение по HTTPS или localhost.';
    }

    return 'Не удалось скопировать чек-лист в системный буфер обмена.';
};
